import styled from 'styled-components';

export const PointsWrapper = styled.div<{ isdisabled: boolean }>`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;

  height: 100%;
  position: absolute;
  padding-right: 56px;
  padding-left: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  color: ${({ theme, isdisabled }) => (isdisabled ? theme.colors.black5 : theme.colors.black9)};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid
    ${({ theme, isdisabled }) => (isdisabled ? theme.colors.black5 : theme.colors.black10)};
  z-index: 0;
`;

export const Wrapper = styled.div`
  width: 80%;
  position: relative;
  margin-left: 50px;

  & > :last-child {
    z-index: 1;
  }
`;
